import bgGraphic from "@assets/bg-graphic.svg";
import bgGraphicMobile from "@assets/bg-graphics-mobile.svg";
import iphone14Image from "@assets/img-iphone-14.png";
import { useWindowSize } from "@hooks/useWindowSize";

/**
 * The graphic component for the Decoding Asia newsletter.
 * @figma https://www.figma.com/design/9O7z95a6ncgr3kFoOqJP7Q/BT-GLOBAL?node-id=18503-30496&m=dev
 */
const Graphic = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <div
      data-testid="graphic-component"
      className="grid grid-cols-1 lg:items-center lg:justify-center"
    >
      <img
        src={isScreenLG ? bgGraphic : bgGraphicMobile}
        alt="graphic background"
        className="col-start-1 row-start-1 max-w-full"
        width={600}
        height={563}
      />

      <img
        src={iphone14Image}
        alt="decoding asia newsletter edition"
        className="col-start-1 row-start-1 mx-auto max-w-full px-16 pt-20 drop-shadow-[13px_4.428px_40.2px_rgba(0,0,0,0.27)] lg:p-0"
        width={277}
      />
    </div>
  );
};

export default Graphic;
